export const APPLICATION_MANIFEST = 'APPLICATION_MANIFEST';
